import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import React from 'react'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'
import MobileIconUi from './ui/MobileIconUi'

type VerticalSpacingProps = {
  verticalSpacing?: number
  change: (val: number) => void
  max?: number
  label?: string
}

function VerticalSpacing({
  verticalSpacing = 0,
  change,
  label = 'settings_styles.vertical_spacing.label',
  max = 100,
}: VerticalSpacingProps) {
  const { isMobile } = useDeviceModeContext()

  return (
    <RangeElement
      labelIcon={isMobile ? <MobileIconUi /> : null}
      label={label}
      value={verticalSpacing}
      max={max}
      onChange={change}
    />
  )
}

export default VerticalSpacing
